export default "__VITE_ASSET__02827395__"